import { getProductCategory } from '@helpers/products'

function getDefaultProductTypeByCategory(category: string) {
  switch (category) {
    case 'trousers':
      return 'heroes'
    case 'tops':
      return 'pique-polo'
    case 'denim':
      return 'original-denim'
    case 'shorts':
      return 'sharp-shorts'
    default:
      return 'leather-belts'
  }
}

function getProductType(productType: string) {
  if (!productType) {
    return undefined
  }
  const productTypeMap = {
    'merino polo - short sleeve': 'merinoshort',
    'merino polo - long sleeve': 'merinolong'
  }
  const type = productType.toLowerCase() as keyof typeof productTypeMap

  return productTypeMap[type] || type
}

const STATIC_CATEGORIES_BY_PRODUCT_TYPE = {
  'The Jack': 'tops'
}

export function sizeChartUrl(
  options: { type: string }[] = [],
  productType = '',
  productCategory = ''
): string {
  const staticCategory =
    STATIC_CATEGORIES_BY_PRODUCT_TYPE[
      productType as keyof typeof STATIC_CATEGORIES_BY_PRODUCT_TYPE
    ]
  const productCategoryValue =
    staticCategory ||
    productCategory ||
    getProductCategory(options, productType)
  const category = productCategoryValue
    ? productCategoryValue.toLocaleLowerCase()
    : 'trousers'

  const sizeChartProductType =
    getProductType(productType) || getDefaultProductTypeByCategory(category)
  return `/pages/${category}-size-chart?type=${sizeChartProductType
    .trim()
    .replace(/\s/g, '-')
    .replace(/---/g, '-')}`
}
